module.exports = __webpack_public_path__ + "img/wangluo.1b65f0fa.png";